<p>new-profil works!</p>
<div id="content" class="main-content">
    <!-- ADD profil MESSAGES ############################################### -->
    <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
       id="profil_added" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
       position: absolute;background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;"> 
       <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
       <strong>Nouveau profil</strong> Ajouté avec succès. {{addedMsg}}
    </div>
    <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
       id="profil_not_added" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
       position: absolute;background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
       <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
       <strong>Ajout Echoué</strong>{{addError}}
    </div>
     <div class="container">
        <div class="col-12 pl-0">
           <div class="crumbs breadcrumbs-style-2">
              <ul class="breadcrumb">
                 <li class="mt-3"><a href="dashboard" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a>
                 </li>
                 <li class="mt-3"><a routerLink="/users/fromprofiles;cs=all" >Profiles</a></li>
                 <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Nouvel profil</a></li>
              </ul>
           </div>
        </div>
       <div class="page-header">
          <div class="page-title mt-3 row col-lg-12 col-md-12">
             <h2 style="color:black">Nouvel profil</h2>
             <div *ngIf="loadingAddingProfil" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-left: 21px;
             margin-bottom: 1%;">
             </div>
          </div>
       </div>
       <form class="form-login" [formGroup]="newProfilForm"  novalidate>
          <div class="row layout-spacing">
             <!-- COLUMN OF FORMULAIRE -->
             <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing">
                <div class="statbox widget box box-shadow">
                   <div class="widget-content widget-content-area" style="border-top-right-radius: 6px;
                      border-top-left-radius: 6px; padding: 65px;">
                      <div class="row form-group mb-3 d-flex justify-content-between">
                        <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <label for="label" class="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-form-label col-form-label-sm">
                            Libellé du profil<span style="color: red;"><b>*</b></span>
                          </label>
                          <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 pr-0 pl-0">
                            <input type="text" class="form-control-rounded form-control" id="label" style="height: fit-content;"
                              placeholder="Saisir libellé du profil" name="label" formControlName="label">
                            <div *ngIf="newProfilForm.get('label')?.errors?.minlength" class="invalid-feedback">
                             Le libellé du profil doit contenir au moins 5 caractères
                            </div>
                            <div *ngIf="newProfilForm.get('label')?.errors?.maxlength" class="invalid-feedback">
                             Le libellé du profil doit contenir au maximum 30 caractères
                            </div>
                            <div *ngIf="newProfilForm.get('label')?.hasError('noSpecialChars')" class="invalid-feedback">
                                Le libellé ne doit pas contenir de caractères spéciaux.
                              </div>
                          </div>
                        </div>
                        <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <label for="description" class="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-form-label col-form-label-sm">
                            Description <span style="color: red;"><b>*</b></span>
                          </label>
                          <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 pr-0 pl-0">
                            <textarea class="form-control-rounded form-control" id="description" style="height: fit-content;"
                              placeholder="Saisir la description" name="description" formControlName="description"></textarea>
                            <div *ngIf="newProfilForm.get('description')?.errors?.minlength" class="invalid-feedback">
                             La description doit contenir au moins 5 caractères
                            </div>
                            <div *ngIf="newProfilForm.get('description')?.errors?.maxlength" class="invalid-feedback">
                                La description doit contenir au maximum 1000 caractères
                                <!-- ⚠️ La description doit contenir au maximum 250 caractères -->
                            </div>
                            <div *ngIf="newProfilForm.get('description')?.hasError('noSpecialChars')" class="invalid-feedback">
                                La description ne doit pas contenir de caractères spéciaux.
                              </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="row form-group mb-3 d-flex justify-content-between">
                        <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <label for="role" class="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-form-label col-form-label-sm">
                                Rôle
                            </label>
                            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 pr-0 pl-0"> 
                                <select class="form-control-rounded form-control" formControlName="role" name="role" id="role">
                                    <option value="">Sélectionner un rôle</option>
                                    <option *ngFor="let role of refRoles" [value]="role.uuid" tp="c" [attr.ud]="role.uuid">{{role.description}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="col">
                            <div class="row tags-content ml-3 mr-3 mt-3" id="selectedactions">
                                <div *ngFor="let role of roles; let i = index">
                                    <span class="badge-chip badge-success mb-3 ml-2 t-secondary" id="badge-chip">
                                        <span class="text">{{ role.description }}</span>
                                        <span class="closebtn pl-2" onclick="this.parentElement.style.display='none'" (click)="removeRole(role)">x</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
             </div>
             <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing">
                <div class="l-a-load-more pt-2 actions_buttons d-flex justify-content-center">
                   <button class="btn progress-button btn-rounded mb-2 pr-5 pl-5 mr-2" style="background-color: #bac5ed;" routerLink="/users/fromprofiles;cs=all">
                      Retour
                   </button>
                   <button id="loading-circle-notification" class="btn btn-gradient-success btn-rounded mb-2 mr-2 pr-5 pl-5"
                   (click)="saveProfil()" [disabled]="newProfilForm.invalid">Enregistrer</button>
                   </div>
             </div>
          </div>
       </form>
     </div>
  </div>